import React from "react";
import { createRoot } from "react-dom/client";
import ProductApp from "./product/ProductApp";
document.title = "Lyncia";
createRoot(document.getElementById("root")).render(<ProductApp />);
